module.exports = __webpack_public_path__ + "img/pen-info.592290d6.png";